export const BRAND_LOGO_SRC = '/assets/images/wellquip-logo.png';
export const BRAND_LOGO_ALT = 'Wellquip Industrial logo';
